import { Scale, Total } from "@pdfking/math"

import type { CalendarArea, CalendarBoxes } from "#internal"

import { Slice } from "../layout/Slice"
import { Area } from "./Area"

/** A calendar's cover: a picture down to a band of paper at its foot, the
 * year in it over the contact. */
export const CalendarCoverAreas = ({
  body,
  contact,
  gap,
  page,
  short,
  year,
}: CalendarBoxes): CalendarArea[] => {
  const [band] = Slice.bottom(body, Scale(short, 0.14))
  return [
    Area.picture(Slice.over(page, Total(band.y, band.height), gap), "cover"),
    Area.text(band, `${year}`),
    Area.footer(contact),
  ]
}
